import React, { useEffect, createElement } from 'react';
import { Toaster } from 'sonner';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { EmotionalTransition } from './components/EmotionalTransition';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { PackComposite } from './components/PackComposite';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TrustBar } from './components/TrustBar';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Meta Pixel Installation
    const pixelId = '1322033292727002';
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
    return () => {
      // Cleanup if needed
      if (document.head.contains(script)) document.head.removeChild(script);
      if (document.head.contains(noscript)) document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-blue-200" data-id="element-0">
      <StickyBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SocialProof data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <EmotionalTransition data-id="element-6" />
        <ProductPresentation data-id="element-7" />
        <WhatIsIncluded data-id="element-8" />
        <PackComposite data-id="element-9" />
        <BonusSection data-id="element-10" />
        <UrgencySection data-id="element-11" />
        <OfferSection data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <TrustBar data-id="element-15" />
        <FAQSection data-id="element-16" />
        <FinalCTA data-id="element-17" />
      </main>

      <PurchasePopup data-id="element-18" />
      <Toaster data-id="element-19" />
    </div>;
}